module.exports = __webpack_public_path__ + "img/pic_HsinchuCounty.b777d07d.jpg";